import { Article as ArticleIcon, Event } from "@mui/icons-material";
import styles from "./Icons.module.css";
export const Book = ({ size }) => {
  return (
    <Icon size={size} className={styles.Book}>
      <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_48_38)">
          <path
            d="M10.375 1.375H3.625C3.00625 1.375 2.5 1.88125 2.5 2.5V11.5C2.5 12.1187 3.00625 12.625 3.625 12.625H10.375C10.9937 12.625 11.5 12.1187 11.5 11.5V2.5C11.5 1.88125 10.9937 1.375 10.375 1.375ZM3.625 2.5H6.4375V7L5.03125 6.15625L3.625 7V2.5Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_48_38">
            <rect
              width="13.5"
              height="13.5"
              fill="white"
              transform="translate(0.25 0.25)"
            />
          </clipPath>
        </defs>
      </svg>
    </Icon>
  );
};
export const Movie = ({ size }) => {
  return (
    <Icon size={size} className={styles.Movie}>
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_110_5)">
          <path
            d="M36 8L40 16H34L30 8H26L30 16H24L20 8H16L20 16H14L10 8H8C5.8 8 4.02 9.8 4.02 12L4 36C4 38.2 5.8 40 8 40H40C42.2 40 44 38.2 44 36V8H36Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_110_5">
            <rect width="48" height="48" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Icon>
  );
};
export const Course = ({ size }) => {
  return (
    <Icon size={size} className={styles.Course}>
     <Event />
    </Icon>
  );
};
export const Test = ({ size }) => {
  return (
    <Icon size={size} className={styles.Test}>
      <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_48_65)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 2.25H3C2.175 2.25 1.5 2.925 1.5 3.75V14.25C1.5 15.075 2.175 15.75 3 15.75H15C15.825 15.75 16.5 15.075 16.5 14.25V3.75C16.5 2.925 15.825 2.25 15 2.25ZM7.5 12.75H3.75V11.25H7.5V12.75ZM7.5 9.75H3.75V8.25H7.5V9.75ZM7.5 6.75H3.75V5.25H7.5V6.75ZM11.115 11.25L9 9.12L10.0575 8.0625L11.115 9.1275L13.4925 6.75L14.5575 7.815L11.115 11.25Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_48_65">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Icon>
  );
};
export const App = ({ size }) => {
  return (
    <Icon size={size} className={styles.App}>
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_113_8)">
          <path
            d="M40 36C42.2 36 43.98 34.2 43.98 32L44 12C44 9.8 42.2 8 40 8H8C5.8 8 4 9.8 4 12V32C4 34.2 5.8 36 8 36H0V40H48V36H40ZM8 12H40V32H8V12Z"
            fill="black"

          />
        </g>
        <defs>
          <clipPath id="clip0_113_8">
            <rect width="48" height="48" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Icon>
  );
};
export const Article = ({ size }) => {
  return (
    <Icon size={size} className={styles.Article}>
      <ArticleIcon />
    </Icon>
  );
};
export const Podcast = ({ size }) => {
  return (
    <Icon size={size} className={styles.Podcast}>
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_113_14)">
          <path
            d="M24 28C27.32 28 29.98 25.32 29.98 22L30 10C30 6.68 27.32 4 24 4C20.68 4 18 6.68 18 10V22C18 25.32 20.68 28 24 28ZM34.6 22C34.6 28 29.52 32.2 24 32.2C18.48 32.2 13.4 28 13.4 22H10C10 28.82 15.44 34.46 22 35.44V42H26V35.44C32.56 34.48 38 28.84 38 22H34.6Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_113_14">
            <rect width="48" height="48" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Icon>
  );
};
const Icon = ({ size, children, className }) => {
  let iconSize;
  if (size) {
    switch (size) {
      case "sm":
        iconSize = 1.5;
        break;
      case "md":
        iconSize = 2.25;
        break;
      case "lg":
        iconSize = 3;
        break;
      default:
        iconSize = size;
        break;
    }
  }
  else {
    iconSize = 1.5;
  }


  return (
    <div
      className={[className, styles.Icon].join(" ")}
      style={{
        width: `${iconSize}rem`,
        height: `${iconSize}rem`,
        minWidth: `${iconSize}rem`,
        minHeight: `${iconSize}rem`,
        maxWidth: `${iconSize}rem`,
        maxHeight: `${iconSize}rem`,
      }}
    >
      {children}
    </div>
  );
};
